import React from 'react';
import StyledLink from '../components/StyledLink';
import { Container, Breadcrumbs, Typography, Tabs, Tab, Table, TableRow, TableCell, TableBody, TableHead, } from '@material-ui/core';
import TabPanel from '../components/TabPanel';
var DatasourcesEdit = function () {
    var _a = React.useState(0), value = _a[0], setValue = _a[1];
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    // TODO: API connection
    var schemas = [
        {
            id: 1,
            name: 'Sample Schema',
        },
    ];
    return (React.createElement(Container, null,
        React.createElement(Breadcrumbs, { "aria-label": "breadcrumb" },
            React.createElement(StyledLink, { color: "inherit", to: "/datasources" }, "Data Sources"),
            React.createElement(Typography, { color: "textPrimary" }, "Schema")),
        React.createElement("h2", null, "Schema"),
        React.createElement(Tabs, { value: value, onChange: handleChange },
            React.createElement(Tab, { label: "Schema" }),
            React.createElement(Tab, { label: "Query Logs" }),
            React.createElement(Tab, { label: "Stats" }),
            React.createElement(Tab, { label: "Settings" })),
        React.createElement(TabPanel, { value: value, index: 0 },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Name"))),
                React.createElement(TableBody, null, schemas.map(function (schema, i) { return (React.createElement(TableRow, { key: i },
                    React.createElement(TableCell, null, schema.name))); })))),
        React.createElement(TabPanel, { value: value, index: 1 },
            React.createElement("h3", null, "Query Logs")),
        React.createElement(TabPanel, { value: value, index: 2 },
            React.createElement("h3", null, "Usage Stats for Past Two Weeks")),
        React.createElement(TabPanel, { value: value, index: 3 },
            React.createElement("h3", null, "Datasource Settings"))));
};
export default DatasourcesEdit;
